module.exports = __webpack_public_path__ + "media/src/website/images/home-teaser-3f04777b025fb36587be7a801ef86705.jpg";